module.exports = __webpack_public_path__ + "static/media/icon_mobile_menu_arrow_down.39c674b9.svg";